const plural = (n: number, one: string, many: string): string => `${n} ${n === 1 ? one : many}`;

/** One line under the Library heading summing up the shelf (mobile's shelf-copy). */
export function shelfLine(notebooks: number, loose: number): string {
  if (notebooks === 0 && loose === 0) return 'An empty shelf — scan a page to get started.';
  const books = plural(notebooks, 'notebook', 'notebooks');
  if (loose === 0) return `${books} · everything filed`;
  return `${books} · ${plural(loose, 'loose page', 'loose pages')}`;
}
